import React, { Component } from 'react';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import { translate } from '../../i18n/customI18nProvider';
import { useRefresh } from 'react-admin';
import { Box, CircularProgress, MenuItem, Paper, TextField, Typography } from '@material-ui/core';

const styles = {
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  paper: {
    backgroundColor: 'whitesmoke',
    borderRadius: '10px',
    padding: '20px',
    minWidth: '80vw'
  },
};

class ClientCheckClass extends Component {

    constructor(props) {
        super(props);
        
        this.state = {
            open: false,
            wristband: '',
            loadedWristband: null,
            iframeLoaded: false,
        }
        this.onClick = props.onClick;
        this.iframeRef = null;
    }

    handleOpen = () => {
        this.setState({open: true});
    }

    handleClose = () => {
        this.setState({
            open: false,
            wristband: '',
            loadedWristband: null,
            iframeLoaded: false,
        });
        this.onClick()
    }

    handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            let loaded = false;
            if(this.state.wristband == this.state.loadedWristband) loaded = true;
            this.setState({wristband: '', loadedWristband: this.state.wristband, iframeLoaded: loaded});
        }
    }

    render() {
        return (
            <div>                
                <MenuItem onClick={this.handleOpen}>
                    {translate('custom.check_client')}
                </MenuItem>
                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    // className={classes.modal}
                    style={styles.modal}
                    open={this.state.open}
                    onClose={this.handleClose}
                    closeAfterTransition
                    disableEnforceFocus={true}
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                >
                    <Fade in={this.state.open}>
                        <div style={styles.paper}>
                            <div style={{ marginBottom: 16 }}>
                                <TextField 
                                    style={{width: '100%'}}
                                    variant='outlined'
                                    onKeyDown={this.handleKeyDown} 
                                    type="text" 
                                    label={translate('custom.uid')} 
                                    value={this.state.wristband || ''} 
                                    onChange={(e) => this.setState({wristband: (e.target.value).toUpperCase()})} 
                                    autoFocus
                                />
                            </div>

                            <div>
                                {
                                // ICI JE VEUX UNE IFRAME QUI AFFICHE LA FICHE CLIENT EN FONCTION DE L'UID SCANNÉ
                                    this.state.loadedWristband ?
                                    <>
                                        {
                                            this.state.iframeLoaded ? null :
                                            <div style={{height: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                                <CircularProgress size={56} />
                                            </div>
                                        }
                                        <iframe 
                                            ref={iframe => (this.iframeRef = iframe)}
                                            title="client_info"
                                            src={`/${this.state.loadedWristband}`}
                                            style={{
                                                width: '100%',
                                                height: '80vh',
                                                border: 'none',
                                                display: this.state.iframeLoaded ? 'block' : 'none'
                                            }}
                                            onLoad={() => {
                                                this.iframeRef.contentWindow.alert = () => {};
                                                this.setState({ iframeLoaded: true });
                                            }}
                                        />
                                    </>
                                    :
                                    <div style={{textAlign: 'center', color: 'gray', height: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                        {translate('custom.scan_wristband')}
                                    </div>
                                }
                            </div>
                        </div>
                    </Fade>
                </Modal>
            </div>
        );
    }

}

const ClientCheck = (props) => {
    
    const refresh = useRefresh();
    return <ClientCheckClass {...props} refresh={refresh} />
}
export default ClientCheck;